import React from 'react';
import styled from 'styled-components';
import { FaCalendar, FaClock, FaBook, FaRupeeSign } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';
import Button from '../common/Button';

const FeaturedSection = styled.section`
  background-color: ${props => props.theme.colors.white};
  padding: 80px 0;
`;

const CourseHighlight = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.lightColor};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const CourseInfo = styled.div`
  flex: 1;
  padding: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 30px 20px;
  }
`;

const CourseTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  color: ${props => props.theme.colors.secondaryColor};
  margin-bottom: 10px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const CourseSubtitle = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 20px;
`;

const CourseDetails = styled.ul`
  list-style: none;
  margin-bottom: 30px;
`;

const CourseDetailItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: ${props => props.theme.fontSizes.regular};
  
  svg {
    color: ${props => props.theme.colors.primaryColor};
    margin-right: 15px;
    font-size: 1.2rem;
  }
`;

const CourseImage = styled.div`
  flex: 1;
  text-align: center;
  padding: 20px;
  
  img {
    max-width: 100%;
    border-radius: 8px;
  }
`;

const FeaturedCourse = () => {
  return (
    <FeaturedSection>
      <div className="container">
        <SectionHeader 
          title="Featured Course" 
          subtitle="Prepare for your future career with our specialized coaching" 
        />
        
        <CourseHighlight>
          <CourseInfo>
            <CourseTitle>TNPSC Combined Technical Services Examination</CourseTitle>
            <CourseSubtitle>Junior Draughting Officer & Overseers</CourseSubtitle>
            <CourseDetails>
              <CourseDetailItem>
                <FaCalendar />
                <span>Starting: April 2, 2025</span>
              </CourseDetailItem>
              <CourseDetailItem>
                <FaClock />
                <span>Duration: 1.5 Months</span>
              </CourseDetailItem>
              <CourseDetailItem>
                <FaClock />
                <span>Timings: 6:30 AM - 8:30 AM & 7:00 PM - 9:00 PM</span>
              </CourseDetailItem>
              <CourseDetailItem>
                <FaBook />
                <span>Coverage: Paper 1 & Paper 2</span>
              </CourseDetailItem>
              <CourseDetailItem>
                <FaRupeeSign />
                <span>Fee: ₹9,900 + GST</span>
              </CourseDetailItem>
            </CourseDetails>
            <Button to="/tnpsc" variant="primary">Learn More</Button>
          </CourseInfo>
          <CourseImage>
            <img src="/placeholder/500/300" alt="TNPSC Coaching" />
          </CourseImage>
        </CourseHighlight>
      </div>
    </FeaturedSection>
  );
};

export default FeaturedCourse;
